import React from 'react';
import styles from './day-calendar-widget.module.scss';
import { observer } from 'mobx-react';
import { DefaultButton } from 'shared/ui';
import { useNavigate } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';

export const DayCalendarWidget: React.FC = observer(() => {
  const navigate = useNavigate();
  return (
    <div className={styles.day_calendar_widget__container}>
      <div className={styles.container__content}>
        <div className={styles.container__title}>
          <div className={styles.title__content}>
            <div className={styles.title__text}>Дневной календарь</div>
            <div className={styles.title__button}>
              <DefaultButton
                buttonText="Перейти"
                className={styles.button_go}
                color="green"
                onClick={() => navigate(AppLinks.DayCalendarLink)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
